import DicomPrintService from './DicomPrintService';

export default DicomPrintService;
